import type { LoginClient } from "@authress/login";
import { type ReactNode, useEffect } from "react";

interface Props {
  authressClient: LoginClient;
  loadingFallback: ReactNode;
}

export function RedirectToAuthressLogin({
  authressClient,
  loadingFallback,
}: Props) {
  useEffect(() => {
    async function redirect() {
      await authressClient.authenticate({ redirectUrl: window.location.href });
    }

    void redirect();
  });

  return loadingFallback;
}
